import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Instructors() {
  const [instructors, setInstructors] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const { t, i18n } = useTranslation("global");

  const fetchInstructors = async (page = 1, lang = "en") => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/instructors?page=${page}`,
        {
          headers: {
            "Accept-Language": lang,
          },
        }
      );
      

      const data = await response.json();
      setInstructors(data.data);
      setCurrentPage(data.pagination.current_page);
      setLastPage(data.pagination.last_page);
    } catch (error) {
      console.error("Error fetching instructors:", error);
    }
  };

  useEffect(() => {
    const lang = i18n.language || "en";
    fetchInstructors(currentPage, lang);
  }, [currentPage, i18n.language]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= lastPage && page !== currentPage) {
      fetchInstructors(page);
    }
  };

  return (
    <>
      <div className="custom-section">
        <div className="container">
          <h1 className="m-0">{t("instructorsPage.title")}</h1>
          <h6 className="m-0">
            <Link className="link-hover" to="/">
              {t("instructorsPage.home")}
            </Link>
            <span> -</span>
            <span className="second-color"> {t("instructorsPage.title")}</span>
          </h6>
        </div>
      </div>

      <section className="container my-5">
        <div className="container mt-5">
          <div className="row">
            {instructors.map((instructor) => (
              <div key={instructor.id} className="col-md-4 mb-3">
                <Link to={`/instructortDetails/${instructor.id}`}>
                  <div className="card p-3">
                    <img
                      src={instructor.image}
                      className="card-img-top img-instructor"
                      alt={instructor.name}
                    />
                    <div className="card-body">
                      <h5 className="card-title fw-bold main-color text-center">
                        {instructor.name}
                      </h5>
                      <p className="card-text paragraph-color text-center">
                        {instructor.position}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center mt-4">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Prev
                </button>
              </li>

              {Array.from({ length: lastPage }).map((_, index) => {
                const page = index + 1;
                return (
                  <li
                    key={page}
                    className={`page-item ${page === currentPage ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                );
              })}

              <li
                className={`page-item ${currentPage === lastPage ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </section>
    </>
  );
}
